(function () {
  'use strict';

  window.MONARA = window.MONARA || {};

  var cfg = (window.mmSettings && window.mmSettings.search) || {};
  var DEBOUNCE = 220;

  MONARA.Search = {
    init: function () {
      this.root = document.getElementById('mm-search');
      this.triggers = document.querySelectorAll('[data-mm-search]');

      if (!this.root) {
        this.degradeTriggers();
        return;
      }

      this.input      = this.root.querySelector('[data-mm-search-input]');
      this.results    = this.root.querySelector('[data-mm-search-results]');
      this.empty      = this.root.querySelector('[data-mm-search-empty]');
      this.suggestions= this.root.querySelector('[data-mm-search-suggestions]');
      this.clearBtn   = this.root.querySelector('[data-mm-search-clear]');
      this.form       = this.root.querySelector('.mm-search__form');

      this.lastFocus = null;
      this.timer = null;
      this.controller = null;

      this.bind();
    },

    degradeTriggers: function () {
      Array.prototype.forEach.call(this.triggers, function (btn) {
        btn.addEventListener('click', function () {
          window.location.href = '/search';
        });
      });
    },

    bind: function () {
      var self = this;

      Array.prototype.forEach.call(this.triggers, function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          self.open(btn);
        });
      });

      this.root.querySelectorAll('[data-mm-search-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.close(); });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.isOpen()) self.close();
      });

      if (this.clearBtn) {
        this.clearBtn.addEventListener('click', function () {
          self.input.value = '';
          self.input.focus();
          self.onInput();
        });
      }

      if (this.input) {
        this.input.addEventListener('input', function () { self.onInput(); });
      }

      if (this.form) {
        this.form.addEventListener('submit', function (e) {
          if (!self.input.value.trim()) e.preventDefault();
        });
      }

      this.root.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var f = self.focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    },

    focusables: function () {
      return Array.prototype.filter.call(
        this.root.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null; }
      );
    },

    isOpen: function () {
      return this.root.getAttribute('aria-hidden') === 'false';
    },

    open: function (trigger) {
      this.lastFocus = trigger || document.activeElement;
      this.root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('mm-no-scroll');
      var self = this;
      window.setTimeout(function () { self.input && self.input.focus(); }, 60);
    },

    close: function () {
      this.root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('mm-no-scroll');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },

    onInput: function () {
      var q = this.input.value.trim();

      if (this.clearBtn) this.clearBtn.hidden = q.length === 0;

      window.clearTimeout(this.timer);

      if (q.length < 2) {
        this.showSuggestions();
        return;
      }

      if (cfg.predictive === false) return;

      var self = this;
      this.timer = window.setTimeout(function () { self.fetch(q); }, DEBOUNCE);
    },

    showSuggestions: function () {
      if (this.suggestions) this.suggestions.hidden = false;
      if (this.results) { this.results.hidden = true; this.results.innerHTML = ''; }
      if (this.empty) this.empty.hidden = true;
    },

    fetch: function (q) {
      var self = this;
      var limit = cfg.limit || 6;

      if (this.controller) this.controller.abort();
      this.controller = new AbortController();

      var url = '/search/suggest.json'
        + '?q=' + encodeURIComponent(q)
        + '&resources[type]=product,collection,query'
        + '&resources[limit]=' + limit
        + '&resources[options][unavailable_products]=last';

      fetch(url, { signal: this.controller.signal })
        .then(function (r) {
          if (!r.ok) throw new Error('respuesta ' + r.status);
          return r.json();
        })
        .then(function (data) { self.render(data, q); })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          self.showSuggestions();
        });
    },

    render: function (data, q) {
      var res = (data && data.resources && data.resources.results) || {};
      var productos = res.products || [];
      var colecciones = res.collections || [];

      if (this.suggestions) this.suggestions.hidden = true;

      if (!productos.length && !colecciones.length) {
        if (this.results) { this.results.hidden = true; this.results.innerHTML = ''; }
        if (this.empty) this.empty.hidden = false;
        return;
      }

      if (this.empty) this.empty.hidden = true;

      var html = '';

      if (colecciones.length) {
        html += '<p class="mm-label mm-search__heading">Colecciones</p><ul class="mm-search__list">';
        colecciones.forEach(function (c) {
          html += '<li><a class="mm-search__row mm-search__row--plain" href="' + c.url + '">' + esc(c.title) + '</a></li>';
        });
        html += '</ul>';
      }

      if (productos.length) {
        html += '<p class="mm-label mm-search__heading">Productos</p><ul class="mm-search__list">';
        productos.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url
            ? '<img class="mm-search__thumb" src="' + p.featured_image.url + '&width=120" alt="" loading="lazy" width="60" height="75">'
            : '<span class="mm-search__thumb mm-search__thumb--empty" aria-hidden="true"></span>';

          html += '<li><a class="mm-search__row" href="' + p.url + '">'
                + img
                + '<span class="mm-search__meta">'
                +   '<span class="mm-label mm-search__brand">' + esc(p.vendor || '') + '</span>'
                +   '<span class="mm-search__title">' + esc(p.title) + '</span>'
                +   '<span class="mm-search__price">' + (p.price ? money(p.price) : '') + '</span>'
                + '</span>'
                + '</a></li>';
        });
        html += '</ul>';
      }

      html += '<a class="mm-search__all" href="/search?q=' + encodeURIComponent(q) + '&type=product">'
            + 'Ver todos los resultados de “' + esc(q) + '”</a>';

      this.results.innerHTML = html;
      this.results.hidden = false;
    }
  };

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function money(valor) {
    var n = typeof valor === 'string' ? parseFloat(valor) : valor;
    if (isNaN(n)) return '';
    return '$' + n.toLocaleString('es-MX', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }) + ' MXN';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { MONARA.Search.init(); });
  } else {
    MONARA.Search.init();
  }
})();
